import { render } from "./students.vue?vue&type=template&id=701d509b&ts=true"
import script from "./students.vue?vue&type=script&lang=ts"
export * from "./students.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__